import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { Subscription } from 'rxjs';
import { MessageError } from 'base-models';
import { AlertService, DialogdeleteComponent, NotifierService } from 'basecomponents';
import { ErrorcontrolService } from 'basecomponents';
import { AlertType, NotificationType } from 'base-models';
import { ControlEnum } from 'solar-bo';

import { AppInjector } from 'base-models';
import { ProfileEnum  } from 'solar-bo';
import { DialogQuestionComponent } from 'basecomponents';
import { AppConfig } from '@solar/app.config';
import { SolarErr } from 'solar-bo';
import { User } from 'solar-bo';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from '@solar/services/global.service';
import { DBG, DebugLevelEnum } from './dbg.model';
import { MatTooltip } from '@angular/material/tooltip';



@Component({
  selector: 'app-base-comp',
  template: ''
})
export class BaseComponent implements OnInit {
  profileEnum = ProfileEnum;
  controlEnum = ControlEnum; //para poder usarlo en el html
  /**
   * name to identify the class
   */
  TAG:string="";

  get user(): User {
    return this.globService.currentUserValue;;
  }
  iseditable: boolean = true;

  myform: FormGroup;
  alertmessage: MessageError | string;
  statusok: boolean;
  submitted = false;
  //todo: eliminar esta campo y usar alertmessage
  listerrmessage: string;

  listOriginal: any[]=[];
  _listFiltered: any[]=[];
  get listFiltered(): any[] { 
    return this._listFiltered; 
  }
  set listFiltered(value:any[]) { 
    this._listFiltered=value; 
  } 

  @Input() ismodal: boolean = false;//lo usamos cuando queremos mostrar el componente en un modal
  @Output() selectedevent = new EventEmitter<any>();
  @Output() selectedItemEvent = new EventEmitter();

  loadinglist: boolean = true;
  get loading(): boolean {
    return this.loadinglist;
  }
  set loading(value: boolean) {
    this.loadinglist = value;
  }

  @Input() editablemode: boolean = true;
  public dialogRef: MatDialogRef<any>;

  public subscriptiontomodelchanges: Subscription;


  public dialog: MatDialog;
  public globService: GlobalService;
  public router: Router;
  public route: ActivatedRoute;
  public alertService: AlertService;
  public notifier: NotifierService;
   //public dbg: DBG;

  public constructor() {
    const injector = AppInjector.getInjector();
    if (injector) {
      this.dialog = injector.get(MatDialog);
      this.globService = injector.get(GlobalService);
      this.router = injector.get(Router);
      this.route = injector.get(ActivatedRoute);
      this.alertService = injector.get(AlertService);
      this.notifier = injector.get(NotifierService);
      //this.dbg = injector.get(DBG);
    }
    else{
      console.error("-----------ERROR ON BASE COMPONENT. INJECTOR IS NULL-----------------");
    }

  }

  ngOnInit() { }

  uiiseditablemodel(element: any) {
    return true;
  }


  fake() {

  }

  clog(classnameMethod, logdesc, obj) {
    console.log(classnameMethod + " " + logdesc, obj);
  }

  handleSuccesLoad(message: string, alertype = AlertType.Success) {
    this.alertmessage = new MessageError(alertype, message);
    this.loadinglist = false;
  }
  handleLoadError(errorObject:{errType:any,err:any}) {
    if (errorObject.errType==SolarErr.ERR_LOAD_SUPERVISION){
      this.router.navigateByUrl(AppConfig.ROUTE_SOLAR + "/supervision-list");
      this.notifyerror(errorObject.err)
      return;
    }
    this.loadinglist = false;
    this.alertmessage = ErrorcontrolService.basichandleError("Error loading supervision", errorObject,null,this.TAG);
  }

  handleError(err, genericMessage="") {
    this.loadinglist = false;
    this.alertmessage = ErrorcontrolService.basichandleError(genericMessage, err,null,this.TAG);
  }



  openDialogDelete(title: string, message: string, model: any): MatDialogRef<DialogdeleteComponent> {
    return DialogdeleteComponent.openDialogDelete(this.dialog, title, message, model);
    //dialogRef.componentInstance.mainActionEmitter.subscribe(()=>myfunction(model,dialogRef));
  }

  openDialogQuestion(title: string, message: string, model?: any): MatDialogRef<DialogdeleteComponent> {
    return DialogQuestionComponent.openDialog(this.dialog, title, message, model);
    //dialogRef.componentInstance.mainActionEmitter.subscribe(()=>myfunction(model,dialogRef));
  }

  showmessage(message: string) {
    this.alertmessage = new MessageError(AlertType.Success, message);
  }
  showerror(message: string,err?:any) {
    this.alertmessage = ErrorcontrolService.basichandleError(message,err,null,this.TAG);
  }

  notifyerror(err, genericMessage?: string) {
    DBG.log(DebugLevelEnum.ERROR,this.TAG,err);
    return ErrorcontrolService.basichandleError(genericMessage, err, this.notifier,this.TAG);
  }
  /**
	 * Show a notification
	 *
	 * @param {string} type    Notification type
	 * @param {string} message Notification message
	 */
  public showNotification(type: NotificationType, message: string): void {
    this.notifier.notify(type, message);
  }
  public showNotificationError(message: string,err?:any) {
    //this.notifier.notify(NotificationType.Error, message);
    return ErrorcontrolService.basichandleError(message, err, this.notifier,this.TAG);
  }  
  public showNotificationInfo(message: string): void {
    this.notifier.notify(NotificationType.Info, message);
  }
  public showNotificationWarning(message: string): void {
    this.notifier.notify(NotificationType.Warning, message);
  }  
  public showNotificationSuccess(message: string): void {
    this.notifier.notify(NotificationType.Success, message);
  }      
  /**
 * Hide oldest notification
 */
  public hideOldestNotification(): void {
    this.notifier.hideOldest();
  }
  /**
	 * Hide newest notification
	 */
  public hideNewestNotification(): void {
    this.notifier.hideNewest();
  }
  /**
 * Hide all notifications at once
 */
  public hideAllNotifications(): void {
    this.notifier.hideAll();
  }

	/**
	 * Show a specific notification (with a custom notification ID)
	 *
	 * @param {string} type    Notification type
	 * @param {string} message Notification message
	 * @param {string} id      Notification ID
	 */
  public showSpecificNotification(type: string, message: string, id: string): void {
    this.notifier.show({
      id,
      message,
      type
    });
  }

	/**
	 * Hide a specific notification (by a given notification ID)
	 *
	 * @param {string} id Notification ID
	 */
  public hideSpecificNotification(id: string): void {
    this.notifier.hide(id);
  }

  navigateto(path: any) {
    this.navigatetoHack(AppConfig.ROUTE_SOLAR + path);
  }
  @ViewChildren(MatTooltip) matTooltipChildren!: QueryList<MatTooltip>;
  navigatetoHack(url) {
    DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"navigatetoHack route matTooltipChildren", url,this.matTooltipChildren);
    if (this.matTooltipChildren){
      this.matTooltipChildren.forEach(elem => elem.hide());
      setTimeout(() => {
        this.router.navigate([url]);
      }, 50);      
    }else{
      this.router.navigate([url]);
    }

  }

  public log(level:DebugLevelEnum=DebugLevelEnum.INFO ,TAG:string, ... val:any){
    if (level>= DBG.DEBUG_LEVEL ){
        let dt:any="["+ DebugLevelEnum[level] + "] [" + TAG +  "] [" + new Date().toUTCString()+ "]";
        
        console.log(dt,val);
    }
    
}
}